module.exports = __webpack_public_path__ + "static/media/deliveryservice.72e57bcc.png";